import React from 'react';
import styled from 'styled-components';
import { View, Icon } from '@components';

const PanelConectores = styled(View)`
  display: flex;
  font-weight: normal;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid #f1f1f1;
  padding: 10px;
`;

const ColumnConectorIdentify = styled(View)`
  display: flex;
  justify-content: center;
  width: 60%;
`;

const ColumnVersao = styled(View)`
  display: flex;
  justify-content: center;
  width: 20%;
`;

const ColumnStatus = styled(View)`
  display: flex;
  justify-content: center;
  width: 20%;
  font-size: 20px;
`;

const IconPendente = styled(View)`
  color: #999999;
  align-items: center;
`;

const IconAtualizado = styled(View)`
  color: #28a745;
`;

const IconAtualizar = styled(View)`
  color: #40a9ff;
  cursor: pointer;
`;

export default function Item({ item }) {
  return (
    <PanelConectores key={item.idConfiguracao}>
      <ColumnConectorIdentify>{item.conectorIdentify}</ColumnConectorIdentify>
      <ColumnVersao>v{item.versao}</ColumnVersao>
      <ColumnStatus>
        {item.status === 'ATUALIZADO' ? (
          <IconAtualizado>
            <Icon.TipIcon icon={<Icon.CheckCircleFilled />} tip="Atualizado" />
          </IconAtualizado>
        ) : item.status === 'DESATUALIZADO' ? (
          <IconPendente>
            <Icon.TipIcon icon={<Icon.MDI type="history" />} tip="Desatualizado" />
          </IconPendente>
        ) : (
          <IconAtualizar>
            <Icon.TipIcon icon={<Icon.UpCircleFilled />} tip="Atualizar" />
          </IconAtualizar>
        )}
      </ColumnStatus>
    </PanelConectores>
  );
}
